var _style, _defs, _path, _path2, _path3, _path4, _defs2, _path5, _defs3, _rect, _defs4, _rect2, _defs5, _path6, _defs6, _path7, _defs7, _rect3, _defs8, _rect4, _defs9, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{clip-path:url(#SVGID_6_);}\n\t.st3{clip-path:url(#SVGID_8_);}\n\t.st4{clip-path:url(#SVGID_10_);}\n\t.st5{clip-path:url(#SVGID_12_);}\n\t.st6{clip-path:url(#SVGID_14_);}\n\t.st7{clip-path:url(#SVGID_16_);}\n\t.st8{clip-path:url(#SVGID_18_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.2,
    y: 0.2,
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,9.7L23.6-1.2C23.5-1.1,23.3-1,23.2-1L34,9.8C34.1,9.7,34.3,9.7,34.5,9.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,21.9L19.7,34.3c0,0.2,0,0.4,0,0.7v0c3.6-3.6,8.5-8.5,12.6-12.5C32.3,22.2,32.2,22,32.1,21.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-3.1,9L8.6-2.8C8.6-3,8.5-3.1,8.4-3.2L-3.7,8.9C-3.5,8.9-3.3,9-3.1,9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-3.5,20.6c-0.2,0-0.4,0.1-0.6,0.1c3.8,3.8,8.8,8.8,12.8,12.7c0.1-0.2,0.1-0.3,0.2-0.5L-3.5,20.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -2.8,
    y: 7.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.2702 14.9784)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.1,14.1L14.3,30l0,0h0c0.2,0,0.4,0,0.7,0l0,0l15-15C30,14.6,30.1,14.4,30.1,14.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -0.8,
    y: 2.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.2271 14.9786)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 17.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.1269 17.4225)",
    className: "st2",
    width: 34.6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 1.2,
    y: -2.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.1845 14.9777)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: 12.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.1433 12.5923)",
    className: "st3",
    width: 34.6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 3.3,
    y: -7.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -0.1411 14.9778)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.3,0.1c-0.1,0-0.2,0-0.3,0L0.1,14.9c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3L15.6,0.1 C15.5,0.1,15.4,0.1,15.3,0.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 7.6,
    y: 3.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.2059 21.0537)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30,14.9L15.2,0.1c-0.3,0-0.5,0-0.8-0.1L30,15.6C30,15.4,30,15.1,30,14.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 2.7,
    y: 1.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.206 17.0031)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: -4.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.706 15.9676)",
    className: "st6",
    width: 0.5,
    height: 34.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -2.2,
    y: -0.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.2059 12.9527)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 0.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.6058 13.9468)",
    className: "st7",
    width: 0.5,
    height: 34.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: -7.1,
    y: -2.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.2059 8.9021)",
    width: 29.5,
    height: 29.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0.1,14.3c0,0.2,0,0.5,0,0.7l14.9,14.9l0,0c0.3,0,0.5,0,0.7,0.1L0.1,14.3z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,0c-0.3,0-0.6,0.1-0.9,0.1c-0.3,0-0.6,0-0.9-0.1H0v13.8c0.1,0.5,0.1,1.1,0.1,1.6c0,0.5,0,0.9-0.1,1.4V30h12.7 c0.3,0,0.6-0.1,0.9-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0,0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.1H30V15.7c0-0.2,0-0.5,0-0.7V0H16.1z  M29.5,29.5h-29v-29h29V29.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.c1cbece24bf0f8b37dd98dab73ece478.svg";
export { ForwardRef as ReactComponent };